import { BoxTitle, ItemBox, ItemWrapper, SearchFieldWrapper } from "../style/ConditionSearch.styled";

export default function SearchFieldView ({ selectedCategoryName }) {
    return (
        <SearchFieldWrapper>
            <BoxTitle>선택 카테고리 : </BoxTitle>
            <ItemWrapper>
                {selectedCategoryName?.map((r, idx) => {
                    return (
                        <ItemBox
                            key={'slaes-channel-idx' + idx}
                            className='item-box'
                        >
                            <span>{r ?? '미지정'}</span>
                        </ItemBox>
                    )
                })}
            </ItemWrapper>
        </SearchFieldWrapper>
    )
}